export default [
  {
    path: '/budgets',
    name: 'budgets',
    component: () =>
      import(
        /* webpackChunkName: 'budgets' */ '@/modules/budgets/_views/Index'
      ),
    redirect: { name: 'budgets_active' },
    children: [
      {
        name: 'budgets_active',
        path: 'active',
        meta: {
          section: 'budgets',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'active-budgets' */ '@/modules/budgets/_views/active/ActiveBudgetsIndex'
          )
      },

      {
        name: 'budgets_archived',
        path: 'archived',
        meta: {
          section: 'budgets',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'archived-budgets' */ '@/modules/budgets/_views/archived/ArchivedBudgetsIndex'
          )
      }
    ]
  },
  {
    path: '/budgets/detail/:id',
    name: 'budget_detail',
    component: () =>
      import(
        /* webpackChunkName: 'budget-detail' */ '@/modules/budgets/_views/detail/BudgetDetailIndex'
      ),
    redirect: { name: 'budget_expense_evolution' },
    children: [
      {
        name: 'budget_expense_evolution',
        path: '/budgets/detail/:id/expense-evolution',
        meta: {
          section: 'budgets',
          breadcrumb: 'budget',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_REGULAR', 'ROLE_ACCOUNT_HOLDER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'budget-expense-evolution' */ '@/modules/budgets/_views/detail/BudgetExpenseEvolutionIndex'
          )
      },
      {
        name: 'budget_members',
        path: `/budgets/detail/:id/members`,
        meta: {
          section: 'budgets',
          breadcrumb: 'budget',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_REGULAR'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'budget-detail-members' */ '@/modules/budgets/_views/detail/BudgetDetailMembersIndex'
          )
      },
      {
        name: 'budgets_transactions',
        path: '/budgets/detail/:id/transactions',
        meta: {
          section: 'budgets',
          breadcrumb: 'budget',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_REGULAR'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'budget-transactions' */ '@/modules/budgets/_views/detail/BudgetTransactionsIndex'
          )
      },
      {
        name: 'budgets_reimbursements',
        path: '/budgets/detail/:id/reimbursements',
        meta: {
          section: 'budgets',
          breadcrumb: 'budget',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_REGULAR'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'budget-reimbursements' */ '@/modules/budgets/_views/detail/BudgetReimbursementsIndex'
          )
      }
    ]
  }
]
